export const Footer = () => {
  return (
    <footer className="landing-footer py-4 mt-5 border-top">
      <div className="container">

        <div className="row align-items-center gy-3">

          <div className="col-md-3 text-md-start text-center">
            <img
              src="https://cdn2.paraty.es/mariabonita-corpo/images/15cba433451f2bd=s250"
              height="55"
              alt="María Bonita Logo"
              className="rounded"
            />
          </div>

          <div className="col-md-6 text-center">
            <p className="mb-0 fw-medium">
              Portal Digital Integral para Atención a Proveedores
            </p>
          </div>

          <div className="col-md-3 d-none d-md-block"></div>

          <div className="col-12 text-center mt-3">
            <p className="mb-1 small">
              © 2026 Hoteles María Bonita. Todos los derechos reservados.
            </p>

            <a
              href="https://www.isasolutionsrm.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none fw-semibold small"
            >
              Desarrollado por ISA SOLUTIONS RM
            </a>
          </div>

        </div>

      </div>
    </footer>
  );
};